import { createFileRoute } from "@tanstack/react-router";

import { OperationRecordsPage } from "./-components/operation-records-page";

export const Route = createFileRoute("/operator/operations")({
  component: OperationRecordsRoute,
});

function OperationRecordsRoute() {
  const { access } = Route.useRouteContext();

  return <OperationRecordsPage permissions={access.permissions} />;
}
